import React, { useEffect, useState } from 'react';
import { LOGS_TAB, LOGS_ORDERS_TAB, LOGS_ADMIN_TAB } from '../constant';
import { GET_ORDER_LOGS, GET_ADMIN_AUTH_LOGS, getFetchRequest } from '../store/requests';
import { makeUrl } from '../constant';

const LogsTab = () => {
    const [activeTab, setActiveTab] = useState(LOGS_ORDERS_TAB);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [logLines, setLogLines] = useState([]);
    const [logPath, setLogPath] = useState('');

    const loadLogs = () => {
        setIsLoading(true);
        setError(null);
        const url = activeTab === LOGS_ADMIN_TAB ? GET_ADMIN_AUTH_LOGS : GET_ORDER_LOGS;
        getFetchRequest(
            makeUrl([url]),
            (data) => {
                setLogLines(Array.isArray(data?.lines) ? data.lines : []);
                setLogPath(data?.path || '');
                setIsLoading(false);
            },
            (err) => {
                setError(err?.message || 'Не удалось загрузить логи');
                setIsLoading(false);
            }
        );
    };

    useEffect(() => {
        loadLogs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab]);

    return (
        <div className="logs-page">
            <div className="logs-tabs">
                <button
                    className={`logs-tabs__button ${activeTab === LOGS_ORDERS_TAB ? 'logs-tabs__button--active' : ''}`}
                    onClick={() => setActiveTab(LOGS_ORDERS_TAB)}
                >
                    Заказы
                </button>
                <button
                    className={`logs-tabs__button ${activeTab === LOGS_ADMIN_TAB ? 'logs-tabs__button--active' : ''}`}
                    onClick={() => setActiveTab(LOGS_ADMIN_TAB)}
                >
                    Админка
                </button>
            </div>

            <div className="logs-panel">
                <div className="logs-panel__header">
                    <div className="logs-panel__path">
                        Файл: {logPath || '—'}
                    </div>
                    <button type="button" className="logs-panel__reload" onClick={loadLogs} disabled={isLoading}>
                        {isLoading ? 'Обновление...' : 'Обновить'}
                    </button>
                </div>

                <div className="logs-panel__body">
                    {error && <div className="logs-panel__error">{error}</div>}
                    {!error && isLoading && <div className="logs-panel__loading">Загрузка...</div>}
                    {!error && !isLoading && (
                        <pre className="logs-viewer">
                            {logLines.length ? logLines.join('') : 'Логи пустые'}
                        </pre>
                    )}
                </div>
            </div>
        </div>
    );
};

export default LogsTab;
